import * as React from "react";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import handleMutationError from "app/utils/handleMutationError";
import { withRouter } from "react-router-dom";

type Props = {
  statusMessage: any;
  deleteStatusMessage: any;
  onClose: Function;
  history: any;
};

type State = {
  loading: boolean;
};

class ApplicationStatusMessageDeleteConfirmationModal extends React.Component<
  Props,
  State
> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  submitDelete = () => {
    this.setState({ loading: true });
    this.props
      .deleteStatusMessage({
        variables: {
          id: this.props.statusMessage.id,
        },
      })
      .then(() => {
        this.props.onClose();
        this.setState({ loading: false });
        window.location.reload(false);
      })
      .catch((error) => {
        handleMutationError(error);
      });
  };

  render() {
    return (
      <>
        <Dialog open onClose={() => this.props.onClose()}>
          <DialogTitle>
            <DialogContentText>
              Confirm deleting the status message:
            </DialogContentText>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              The following message{" "}
              <strong>{this.props.statusMessage.message_body}</strong> will be
              deleted.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.submitDelete}>
              Confirm
            </Button>
            <Button color="secondary" onClick={() => this.props.onClose()}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const deleteStatusMessage = graphql(
  gql`
    mutation deleteStatusMessage($id: ID!) {
      delete_status_message(id: $id) {
        id
      }
    }
  `,
  { name: "deleteStatusMessage" }
);

export default withRouter(
  compose<any>(deleteStatusMessage)(
    ApplicationStatusMessageDeleteConfirmationModal
  )
);
